import {
  HStack,
  InlineFormattedNumber,
  NumberVariants,
  Text,
  VStack,
  formattedTimeWithMillis,
  prettifyLedgerUpdateTypeEnum,
  readableDate,
  toBig,
  type Asset,
  type LedgerEvent,
} from '@talos/kyoko';

interface LedgerEventTooltipProps {
  ledgerEvents: LedgerEvent[];
  assetInfo: Asset;
}

export const LedgerEventTooltip = ({ ledgerEvents, assetInfo }: LedgerEventTooltipProps) => {
  if (ledgerEvents.length === 0) {
    return null;
  }

  const firstLedgerEvent = ledgerEvents[0];
  return (
    <VStack minWidth="200px" w="100%" color="colorTextDefault" gap="spacing8">
      <HStack justifyContent="space-between" w="100%" fontSize="fontSizeDefault">
        <Text color="colorTextImportant">{formattedTimeWithMillis(firstLedgerEvent.TransactTime)}</Text>
        <Text>{readableDate(firstLedgerEvent.TransactTime)}</Text>
      </HStack>
      {ledgerEvents.map(le => (
        <LedgerEventTooltipItem ledgerEvent={le} assetInfo={assetInfo} key={le.rowID} />
      ))}
    </VStack>
  );
};

function LedgerEventTooltipItem({ ledgerEvent, assetInfo }: { ledgerEvent: LedgerEvent; assetInfo: Asset }) {
  const numberVariant: NumberVariants | undefined = toBig(ledgerEvent.Amount)?.lt(0)
    ? NumberVariants.Negative
    : undefined;
  return (
    <HStack w="100%" justifyContent="space-between" fontSize="fontSizeSmall" gap="spacing8">
      <Text>{prettifyLedgerUpdateTypeEnum(ledgerEvent.Type)}</Text>
      <InlineFormattedNumber
        variant={numberVariant}
        number={ledgerEvent.Amount}
        currency={assetInfo.Symbol}
        truncate={false}
        align="right"
      />
    </HStack>
  );
}
